<script>
import ModalComponent from "../../../../../components/ModalComponent.vue";
import { computed } from "vue";

export default {
  name: "ModalInfoComponent" ,
  components: {
    ModalComponent
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    createSubmitPreOrderHandler: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const show = computed(() => props.show);

    return {
      show,
    }
  }
}
</script>

<template>
  <modal-component v-model:show="show" title="Дополнительная информация" :width-percent="50" :min-width-px="400">
    <template v-slot:body>
      <div class="notify-content">
        <ul>
          <li>1) Если стоимость вашего заказа менее 2000 руб, то <b>оплата будет после готовности</b> и подтверждения заказа. Оплатить вы сможете прямо в личном кабинете картой или по QR-коду. При сумме более 2000 руб. потребуется оплатить 50% стоимости заказа после нашей проверки приложенных документов и подтверждения заказа.</li>
          <li>2) Если по указанным данным свидетельства о смерти к заказу было "привязано" наследственное дело и ведущий его нотариус, то после готовности и оплаты оценки Вы сможете направить ее результаты прямо нотариусу, <b>нажав в заказе кнопку "ОТПРАВИТЬ НОТАРИУСУ"</b>.</li>
        </ul>
        <div class="align-right">
          <button type="button" @click="createSubmitPreOrderHandler" class="btn btn-primary">Отправить на проверку</button>
        </div>
      </div>
    </template>
  </modal-component>
</template>

<style scoped>

.notify-content li {
  padding: 10px 0;
  font-size: 17px;
  line-height: 24px;
}

.notify-content button {
  background-color: #3194ca;
  border: none;
}

</style>
